import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AgentProductionStatusHandlerComponent } from './agent-production-status.handler';
import { AgentService } from 'src/app/agent/services/agent.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { NgbCalendar, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductionService } from 'src/app/production/services/production.service';

@Component({
  selector: 'sym-agent-production-status',
  templateUrl: './agent-production-status.component.html',
  styleUrls: ['./agent-production-status.component.scss'],
})
export class AgentProductionStatusComponent extends AgentProductionStatusHandlerComponent implements OnInit {
  constructor(
    agentService: AgentService,
    route: ActivatedRoute,
    public router: Router,
    public settingService: SettingService,
    private modalService: NgbModal,
    calendar: NgbCalendar,
    productionService: ProductionService
  ) {
    super(agentService, settingService, router);
  }
}
